import {
  ControlRoot,
  ControlRowContent,
  ControlRowContentRow,
  ControlRowLabel,
  RadioButton,
  RadioButtonsWrap,
} from '@upright/ui/views/render-view/controls/shared';

export const BooleanRadioButtonControl = (props: {
  texts: { title: string; true: string; false: string };
  currentValue: boolean;
  onChange: (newValue: boolean) => void;
}) => {
  return (
    <ControlRoot>
      <ControlRowLabel>{props.texts.title}</ControlRowLabel>
      <ControlRowContent>
        <ControlRowContentRow>
          <RadioButtonsWrap>
            <RadioButton
              checked={props.currentValue}
              onSelect={() => {
                props.onChange(true);
              }}
              label={props.texts.true}
            />
            <RadioButton
              checked={!props.currentValue}
              onSelect={() => {
                props.onChange(false);
              }}
              label={props.texts.false}
            />
          </RadioButtonsWrap>
        </ControlRowContentRow>
      </ControlRowContent>
    </ControlRoot>
  );
};
